export default __webpack_public_path__ + "static/media/le_touquet.93b639bf.jpg";